import type { ObjectMetadata } from '@olytic/foundation';

import { formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS['product-resource-roles'];
const share = show((v) => `${formatNumber(v)}%`);

/** One role's share of a product's hours. Rationale: product-resource-roles.md. */
export const productResourceRoles: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Role share',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('product_name', 'Product', { link: lookup('products', 'product_id') }),
    field('resource_role_name', 'Role', { link: lookup('resource-roles', 'resource_role_id') }),
    field('share_pct', 'Share of Hours (%)', { format: share }),
    field('product_total', "Product's Total", { format: share }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['product_name', 'resource_role_name', 'share_pct', 'product_total'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'product_name', 'resource_role_name'],
};
